var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileIconHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\xA2\x85\xED\x95\xA9\xEB\xB3\x91\xEC\x9B\x90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57567 4.16602H14.423C15.2016 4.16602 15.8327 4.79714 15.8327 5.57567V14.423C15.8327 15.2016 15.2016 15.8327 14.423 15.8327H5.57567C4.79714 15.8327 4.16602 15.2016 4.16602 14.423V5.57567C4.16602 4.79714 4.79714 4.16602 5.57567 4.16602ZM10.9326 9.06543H13.7442V10.9346H10.9326V13.7461H9.06348V10.9346H6.25195V9.06543H9.06348V6.25391H10.9326V9.06543Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIconHospital);
export default __webpack_public_path__ + "static/media/mobile-icon-hospital.e0eeb7d323e69a000e24d46b67d93816.svg";
export { ForwardRef as ReactComponent };